module.exports = __webpack_public_path__ + "static/media/sangbeen.6fb2f3c7.jpg";